import React, {Fragment} from 'react'
import styles from './HighlightedPhoto.scss'
import {Loadable} from 'common/Loadable'
import {Gallery} from 'features/gallery/Gallery'
import {Overlay} from 'common/styleguide/Overlay'
import {request} from 'lib/apiv3/utils/request'
import {urls} from 'lib/urls'
import _ from 'lodash'

const loadPhotosForTRoute = _.memoize(({parentType, parentId}) => {
  return request.get(`/${parentType}s/${parentId}.json?exclude_track_points=true&version=2`)
})

// This component is just supposed to pull out the right data from the `loadableResources` and pass it all in to the gallery.
const PhotoGalleryLauncher = (props) => {
  const {parentType, parentId, loadableResources, ...filteredProps} = props
  const parent = loadableResources[parentType]
  const {highlighted_photo_id: highlightedPhotoId} = parent

  return <Gallery
    photos={parent.photos}
    activePhotoId={highlightedPhotoId}
    parentType={parentType}
    parentId={parentId}
    photosetId
    {...filteredProps} />
}

const LoadableGallery = (props) => {
  return <Loadable
    {...props}
    component={PhotoGalleryLauncher}
    loadingText='Loading Photos'
    resourceLoaded={() => loadPhotosForTRoute(props)} />
}

export class HighlightedPhoto extends React.PureComponent {
  static defaultProps = {
    readonly: true
  }

  constructor (props) {
    super(props)
    this.state = {
      showGallery: false
    }
  }

  onClick = () => {
    this.setState({showGallery: true})
  }

  closeGallery = () => {
    this.setState({showGallery: false})
  }

  render () {
    const {photoId, style, ...props} = this.props
    const {showGallery} = this.state

    if (!photoId) return null

    return (
      <Fragment>
        {showGallery &&
          <Overlay
            onRequestClose={this.closeGallery}>
            <LoadableGallery
              onRequestClose={this.closeGallery}
              coverId={photoId}
              {...props} />
          </Overlay>}
        <img className={styles.HighlightedPhoto} src={urls.photos.profile(photoId)} onClick={this.onClick} style={style} />
      </Fragment>
    )
  }
}
